const FCM_ENABLED = process.env.REACT_APP_FCM_ENABLED === 'true';

let messagingInstance = null;

export const isFcmEnabled = () => FCM_ENABLED;

const getFirebaseConfig = () => ({
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
});

export const initFirebaseMessaging = async () => {
    if (!FCM_ENABLED) return null;

    const config = getFirebaseConfig();
    if (!config.apiKey || !config.projectId) {
        console.warn('[FCM] Faltan variables REACT_APP_FIREBASE_* en .env');
        return null;
    }

    try {
        const { initializeApp } = await import('firebase/app');
        const { getMessaging, getToken, onMessage, isSupported } = await import('firebase/messaging');

        const supported = await isSupported();
        if (!supported) {
            console.warn('[FCM] Messaging no soportado en este navegador');
            return null;
        }

        const app = initializeApp(config);
        messagingInstance = getMessaging(app);

        return { messaging: messagingInstance, getToken, onMessage };
    } catch (err) {
        console.warn('[FCM] No se pudo inicializar Firebase:', err.message);
        return null;
    }
};

export const requestNotificationPermission = async () => {
    if (!('Notification' in window)) return 'unsupported';
    return Notification.requestPermission();
};

export const registerWebPushToken = async () => {
    if (!FCM_ENABLED) return null;

    const permission = await requestNotificationPermission();
    if (permission !== 'granted') return null;

    const firebase = await initFirebaseMessaging();
    if (!firebase) return null;

    const { messaging, getToken, onMessage } = firebase;
    const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;

    if (!vapidKey) {
        console.warn('[FCM] Falta REACT_APP_FIREBASE_VAPID_KEY en .env');
        return null;
    }

    let registration;
    try {
        registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    } catch (err) {
        console.warn('[FCM] No se pudo registrar service worker:', err.message);
        return null;
    }

    const token = await getToken(messaging, {
        vapidKey,
        serviceWorkerRegistration: registration,
    });

    if (!token) return null;

    onMessage(messaging, (payload) => {
        const { title, body } = payload.notification || {};
        showBrowserNotification(title || 'Nueva notificación', {
            body: body || '',
            data: payload.data,
            onClick: () => {
                const courseId = payload.data?.courseId;
                if (courseId) {
                    window.location.href = `/curso/${courseId}`;
                }
            },
        });
    });

    return token;
};

export const showBrowserNotification = (title, options = {}) => {
    if (Notification.permission !== 'granted') return;
    if (options.userPreferences?.enabled === false) return;
    if (options.userPreferences?.channels?.browserPush === false) return;

    const notification = new Notification(title, {
        body: options.body,
        icon: options.icon || '/favicon.ico',
        tag: options.tag,
        data: options.data,
    });

    if (options.onClick) {
        notification.onclick = options.onClick;
    }
};
